// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"406":"9891ef41","636":"b770852d","806":"b07c989b"}[chunkId] + ".css";
};